import styled from '@emotion/styled';
import { useEffect } from 'react';
import { OfferCard } from 'ui/components/buyer/patterns/MatchList/OfferCard';
import { SnackBar } from 'ui/components/elements/SnackBar/SnackBar';
import { useRequestMeetList } from './useRequestMeetList';
import { DeclineMeetingRequest } from 'ui/components/screens/modals/DeclineMeetingRequest/DeclineMeetingRequest';
import { useModal } from 'ui/components/screens/modals/useModal';
import { PROFILE_STAGE } from 'domain/entities/BuyerUser/BuyerUser';
import { NeedProfileRegistration } from 'ui/components/buyer/screens/modals/NeedProfileRegistration/NeedProfileRegistration';
import { PremiumOffer } from 'ui/components/buyer/screens/modals/PremiumOffer/PremiumOffer';

const Wrapper = styled.div`
    display: flex;
    gap: 20px;
    flex-direction: column;
    margin-top: 40px;
    margin-bottom: 40px;
`;

const Title = styled.h1`
    font-weight: 700;
    font-size: 18px;
`;

export const RequestMeetList: React.FC = () => {
    const {
        accept,
        decline,
        setValue,
        loading,
        errors,
        user,
        premiumOffers,
        showSnackbar,
        setShowSnackbar,
        showSnackbarMessage,
        openModal,
        createModal,
    } = useRequestMeetList();

    const needRegistrationModal = useModal();
    const needShowModal = user?.account_profile_stage !== PROFILE_STAGE.COMPLETE;
    const { openModal: openNeedRegistrationModal, createModal: createNeedRegistrationModal } = needRegistrationModal;
    const {
        openModal: openPremiumOfferModal,
        createModal: createPremiumOfferModal,
        closeModal: closePremiumOfferModal,
    } = useModal();

    const onClickDeclineButton = (match_id: number) => {
        closePremiumOfferModal();
        if (needShowModal) {
            openNeedRegistrationModal();
            return;
        }
        setValue('match_id', match_id);
        openModal();
    };

    const onClickAcceptButton = (match_id: number) => {
        closePremiumOfferModal();
        if (needShowModal) {
            openNeedRegistrationModal();
            return;
        }
        accept(match_id);
    };

    useEffect(() => {
        if (premiumOffers.length > 0) {
            openPremiumOfferModal();
        }
    }, [premiumOffers]);

    return (
        <Wrapper>
            <Title>オファー一覧</Title>
            {!loading &&
                user?.waiting_request_meeting &&
                user.waiting_request_meeting.map((request) => (
                    <OfferCard
                        key={request.id}
                        offer={request}
                        onAccept={onClickAcceptButton}
                        onDecline={onClickDeclineButton}
                    />
                ))}
            {createModal(
                <DeclineMeetingRequest
                    onClick={decline}
                    setValue={(value) => setValue('reason', value)}
                    errorMsg={errors.reason?.message || ''}
                    loading={loading}
                />,
            )}
            {createNeedRegistrationModal(<NeedProfileRegistration />)}
            {createPremiumOfferModal(
                <PremiumOffer
                    premiumOffers={premiumOffers}
                    onClickDeclineButton={onClickDeclineButton}
                    onClickAcceptButton={onClickAcceptButton}
                    loading={loading}
                />,
            )}
            <SnackBar message={showSnackbarMessage} open={showSnackbar} setOpen={setShowSnackbar} />
        </Wrapper>
    );
};
